<template>
    <component v-if="noticeData" :is="'Component' + noticeData.type" :notice-data="noticeData" :is-vertical="isVertical" :is-complete="isComplete" />
</template>

<script>
import '@/assets/less/quill.snow.css'
import Component1 from './picComponent'
import Component2 from './textComponent'
import Component3 from './picTextComponent'
export default {
    name: 'NoticeDetail',
    components: {
        Component1,
        Component2,
        Component3
    },
    data () {
        return {
            uid: '',
            noticeId: '',
            noticeData: null,
            isVertical: false,
            isComplete: false,
            isClick: false
        }
    },
    created () {
        this.noticeId = this.$route.params.id
        this.uid = this.$route.params.uid
        // console.log(this.noticeId)
        // console.log(this.uid)
        this.getNoticeContent()
        this.screenChange()
        this.handleScreenChange = this.screenChange.bind(this)
        window.addEventListener('orientationchange', this.handleScreenChange)
    },
    beforeDestroy () {
        window.removeEventListener('orientationchange', this.handleScreenChange)
    },
    methods: {
        getNoticeContent () {
            this.$apis.gameNoticeShow({
                userId: this.uid,
                noticeId: this.noticeId
            }).then(res => {
                // if (res.state * 1 !== 1) return this.$Toast(res.msg)
                this.noticeData = res || {}
                setTimeout(() => {
                    this.isComplete = true
                }, 200)
            })
        },
        // 给客户端外链
        giveOutLink (url) {
            if (url) {
                if (!this.isClick) {
                    this.isClick = true
                    this.$apis.noticeLinkClick({
                        userId: this.uid,
                        noticeId: this.noticeId
                    })
                }
                $jsBridge.call('web_openOutsideLink', { url: url })
            }
        },
        // 关闭弹窗
        closeWindow () {
            $jsBridge.call('web_closeWindow')
        },
        screenChange () {
            this.isVertical = window.orientation === 0 || window.orientation === 180
        }
    }
}
</script>

<style>
.notice-close {
    position: absolute;
    width: 36px;
    height: 36px;
    right: 5px;
    top: 5px;
    cursor: pointer;
    background-image: url('../../assets/images/close.svg');
    background-position: center;
    background-size: 80% auto;
    background-color: rgba(0, 0, 0, .6);
    border-radius: 50%;
}
</style>
